let wrap = undefined;
export function setBrandTopAndHomeLinkProps(params) {
    wrap = params;
}
export function getBrandTopAndHomeLinkProps() {
    return wrap;
}
//# sourceMappingURL=brandTopAndHomeLinkProps.js.map